import { TOASTS_SET_HAS_SHOWN_MULTIPACK_MESSAGE_FOR } from '../actionConstants';
import defaultState from './toastsDefaultState';
import { Toasts } from './toastsTypes';

export default (state: Toasts = defaultState, action: any) => {
  switch (action.type) {
    case TOASTS_SET_HAS_SHOWN_MULTIPACK_MESSAGE_FOR:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};
